import { nightOpsTheme } from './nightOps';
import { shadowGridTheme } from './shadowGrid';
import { modernWarfareTheme } from './modernWarfare';

export type Theme = typeof nightOpsTheme;

export const themes = {
  nightOps: nightOpsTheme,
  shadowGrid: shadowGridTheme,
  modernWarfare: modernWarfareTheme,
};

export type ThemeName = keyof typeof themes;
